

const IOLConsent = ({
    pageRefs,
    currentPage,
    logo,
    pageTitles,
    SurgeryFormData,
    surgeonOptionsMap,
    docSignature,
    setSignatures,
    setSurgeryFormData,
    handleInputChange,
    invalidFields,
    isNext,
    isEditing,
    signatures,
    canvasRefs,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    getCentralAmericaDate,
    getCentralAmericaTime,
    Logo,
    Head,
    Paragraph,
    RadioGroup,
    TextInput,
    SignatureField,
    SegLogoBanner,
    Initials,
    surgeryUpload,
    FormInput,
    formattedDate
}) => {

    return (
        <div ref={pageRefs.current[currentPage]} className="max-w-5xl w-full bg-white">
            <div className="px-1 mx-8 py-2">
                <Head title="Informed Consent Form for Cataract Surgery or
                Placement of Intraocular Lenses" />

                <span className="font-bold">WHAT IS A CATARACT AND HOW IS IT TREATED?</span>
                <Paragraph>
                    The lens in the eye can become cloudy and hard, a condition known as cataract. Cataracts can develop from normal aging,
                    from an eye injury, or if you have taken medications known as steroids. Cataracts may cause blurred vision, dulled vision,
                    sensitivity to light and glare, and/or ghost images. If the cataract changes vision so much that it interferes with your daily life, that
                    cataract may need to be removed. Surgery is the only way to remove a cataract. You can decide not to have the cataract
                    removed. If you do not have the surgery, your vision loss from the cataract will continue to get worse.                </Paragraph>
                <span className="font-bold">HOW WILL REMOVING THE CATARACT AFFECT MY VISION?</span>
                <Paragraph>
                    The goal of cataract surgery is to correct the decreased vision that was caused by the cataract. During the surgery, the
                    ophthalmologist (eye surgeon) removed the cataract and puts in a new artificial lens called an intraocular lens or IOL. Cataract
                    surgery will not correct other causes of decreased vision, such as glaucoma, diabetes, or age-related macular degeneration.
                    Most people still need to wear glasses or contact lenses after cataract surgery for either near and/or distance vision and
                    astigmatism.
                </Paragraph>
                <span className="font-bold">WHAT TYPES OF INTRAOCULAR LENSES (IOLs) ARE AVAILABLE?</span>
                <Paragraph>
                    Your ophthalmologist will help you decide on the type of IOL that will replace your cloudy lens. There are IOLs available to
                    treat nearsightedness (myopia), farsightedness (hyperopia), and astigmatism. IOLs usually provide either near or distance
                    vision: these single focus lenses are called monofocal IOLs. Some newer IOLs can provide for near, intermediate, and distance
                    vision: these multiple focus lenses are called multifocal IOLs. IOLs that treat astigmatism are called Toric IOLs. You can also
                    have one eye corrected for near vision, and the other for distance vision, a choice called monovision.                </Paragraph>
                <span className="font-bold">WHAT IS ASTIGMATISM? ARE THERE OTHER TREATMENTS FOR IT?</span>
                <Paragraph>
                    Patients with nearsightedness and farsightedness often also have astigmatism. An astigmatism is caused by an irregularly
                    shaped cornea; instead of being round like a basketball, the cornea is shaped like a football. This can make your vision blurry.
                    In addition to Toric IOLs, astigmatism can be reduced by glasses, contact lenses, and refractive surgery (LASIK or PRK). There
                    is also a procedure called a limbal relaxing incision (LRI), which can be done at the same time as the cataract operations, or as a
                    separate procedure. A limbal relaxing incision (LRI) is a small cut or incision the ophthalmologist makes into your cornea to
                    make its shape rounder. Any attempt at astigmatism reduction could result in over- or under-correction, in which case glasses,
                    contact lenses, or another procedure may be needed.
                </Paragraph>
                <span className="font-bold">WHAT ARE THE MAJOR RISKS OF CATARACT SURGERY?</span>
                <Paragraph>All operations and procedures are riblue and can result in unsuccessful results, complications, injury, or even death, from
                    both known and unknown causes. The major risks of cataract surgery include but are not limited to bleeding, infection, injury to
                    parts of the eye and nearby structures from anesthesia, the operation itself, or pieces of the lens that cannot be removed; high
                    eye pressure; a detached retina, and a droopy eyelid. The major risks of a limbal relaxing incision are similar to those for
                    cataract surgery, but also include loss of vision, damage to the cornea, and scarring under- or over-correction could occur.
                    Depending upon your eye and the type of IOL, you may have increased night glare or halos, double vision, ghost images,
                    impaired depth perception, blurry vision, and trouble driving at night. The ophthalmologist might not be able to put in the IOL you
                    choose. In addition, the IOL may later need to be repositioned or replaced.
                    Depending upon the type of anesthesia, other risks are possible, including cardiac and respiratory problems, and, in rare
                    cases, death.

                </Paragraph>
                <Paragraph>
                    There is no guarantee that cataract surgery or astigmatism reduction will improve your vision. As a result of the surgery
                    and/or anesthesia, it is possible that your vision could be made worse. In some cases, complications may occur weeks. months
                    or even years later. These and other complications may result in poor vision, total loss of vision, or even loss of the eye in rare
                    situations. You may need additional treatment or surgery to treat these complications This additional treatment is not included
                    in the fee for this procedure.
                </Paragraph>
            </div>
        </div>
    );
};

export default IOLConsent;